// extracted by mini-css-extract-plugin
export default {"additional-detail-field-input":"styles_additional-detail-field-input__BgHp-"};